import React from 'react';

const True = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 13L8 19L21 6" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export default True;
